import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17 11V2h-1v9h1zm-1 1v6h1v-6h-1zM10.5 6V2h-1v4h1zm-1 1v11h1V7h-1zM4 9V2H3v7h1zm-1 1v8h1v-8H3z" fill="currentColor" /><path fill="currentColor" d="M1 10h5v1H1zM14 12h5v1h-5zM7.5 5h5v1h-5z" /></svg>;